import { useTranslation } from 'react-i18next'
import localizeDuration from '../helpers/localizeDuration'
import useCountdown from '../hooks/useCountdown'
import { Plan, StripePrice } from '../types'
import SubscriptionForm from './SubscriptionForm'

interface Props {
  countdownUntil: number
  currency: string
  isSubmitting: boolean
  plan: Plan
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
  stripePriceFull: StripePrice | undefined
}

export default function LimitedTimeOfferBanner({
  countdownUntil,
  currency,
  isSubmitting,
  plan,
  priceId,
  setIsSubmitting,
  stripePriceFull,
}: Props) {
  const duration = useCountdown(countdownUntil)
  const { t } = useTranslation()

  if (countdownUntil < Date.now()) return null

  return (
    <div className="bg-primary/5 space-y-3">
      <div className="custom-container flex grow flex-row items-center justify-between py-4">
        <div className="flex flex-col">
          <p className="font-bold text-black">
            {t('pages.checkout.plans.discount_reserved')}
          </p>

          <p className="text-3xl font-bold text-black">
            {localizeDuration({ duration })}
          </p>
        </div>

        <SubscriptionForm
          buttonClassName="!px-3 !py-2 !font-bold !text-base !shadow-none"
          buttonTitle={t('buttons.startNow')}
          currency={currency}
          isSubmitting={isSubmitting}
          plan={plan}
          priceId={priceId}
          setIsSubmitting={setIsSubmitting}
          stripePriceFull={stripePriceFull}
        />
      </div>
    </div>
  )
}
